// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"6ed1e03e","453":"406c13f6","490":"96f6af20","941":"769dac94"}[chunkId] + ".chunk.js";
};